import { render, staticRenderFns } from "./addViolation.vue?vue&type=template&id=8f86ba44&scoped=true"
import script from "./addViolation.vue?vue&type=script&lang=js"
export * from "./addViolation.vue?vue&type=script&lang=js"
import style0 from "./addViolation.vue?vue&type=style&index=0&id=8f86ba44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86ba44",
  null
  
)

export default component.exports